var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildngsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:company"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.5003 20H21.8337V22.6667H24.5003M24.5003 14.6667H21.8337V17.3333H24.5003M27.167 25.3333H16.5003V22.6667H19.167V20H16.5003V17.3333H19.167V14.6667H16.5003V12H27.167M13.8337 9.33333H11.167V6.66667H13.8337M13.8337 14.6667H11.167V12H13.8337M13.8337 20H11.167V17.3333H13.8337M13.8337 25.3333H11.167V22.6667H13.8337M8.50033 9.33333H5.83366V6.66667H8.50033M8.50033 14.6667H5.83366V12H8.50033M8.50033 20H5.83366V17.3333H8.50033M8.50033 25.3333H5.83366V22.6667H8.50033M16.5003 9.33333V4H3.16699V28H29.8337V9.33333H16.5003Z",
    fill: "#00C46B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildngsvg);
export default __webpack_public_path__ + "static/media/buildngsvg.35ac70b108400d055dd8918dd6120a15.svg";
export { ForwardRef as ReactComponent };